<template src="./AdminVisionDoctor.html" />

<script>
import appointment from "../Schedule/Appointment/Appointment.vue"
import pendingSchedule from "../Schedule/PendingSchedule/PendingSchedule.vue"
import medicalRecords from "../MedicalRecords/MedicalRecords/MedicalRecords.vue"
import pendencyMedicalRecords from "../MedicalRecords/PendencyMedicalRecords/PendencyMedicalRecords.vue"
import myPatients from "../MyPatients/MyPatients.vue"
import financialExtract from "../FinancialExtract/FinancialExtract.vue"
import profile from "../Profile/ProfileDoctor/Profile.vue"
import clinicsDoctor from "../Profile/Clinic/ListClinics/ListClinics.vue"
import clinic from "../Profile/Clinic/Clinic/Clinic.vue"
import dashboardDoctor from "../DashboardDoctor/DashboardDoctor.vue"
import contracts from "../Contracts/Contracts.vue"
import campaigns from "../Campaigns/Campaigns.vue"
import Balance from "@/views/pages/Balance/Balance"

export default {
  components: {
    appointment,
    profile,
    clinic,
    dashboardDoctor,
    pendingSchedule,
    medicalRecords,
    pendencyMedicalRecords,
    myPatients,
    financialExtract,
    clinicsDoctor,
    contracts,
    campaigns,
    Balance,
  },
  data () {
    return {
      doctorName: "",
      appointmentShow: false,
      pendingScheduleShow: false,
      medicalRecordsShow: false,
      pendencyMedicalRecordsShow: false,
      myPatientsShow: false,
      financialExtractShow: false,
      balanceAndFinancialDataShow: false,
      profileShow: false,
      doctorClinicShow: false,
      dashboardDoctorShow: false,
      campaignsShow: false,
      contractsShow: false,
      bearerDefault: ""
    }
  },
  mounted () {
    const vm = this
    vm.bearerDefault = vm.$session.get("bearerDefault")
    vm.$session.set("bearerDefault", vm.bearerDefault)
    if (vm.$route.params) {
      vm.doctorName = vm.$route.params.name.toUpperCase()
      vm.init()
    }
  },
  methods: {
    init () {
      const vm = this
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      )
      vm.axios
        .put(
          vm.$store.state.filooServer +
          "admin/doctors/" +
          vm.$route.params.id +
          "/getAssume"
        )
        .then(function (response) {
          vm.authenticateAsAdmin(response.data.token)
        })
    },
    authenticateAsAdmin (token) {
      const vm = this
      vm.axios
        .put(vm.$store.state.filooServer + "doctor/assume/" + token)
        .then(function (response) {
          vm.$session.set("bearer", response.headers.authorization)
          vm.dashboardDoctorShow = true
        })
    },
    goToDoctorsRegistered () {
      const vm = this
      vm.$session.set("bearer", vm.bearerDefault)
      vm.$session.start()
      vm.$router.push("/doctors-registered")
    },
    showContracts () {
      const vm = this
      vm.appointmentShow = false
      vm.pendingScheduleShow = false
      vm.medicalRecordsShow = false
      vm.pendencyMedicalRecordsShow = false
      vm.myPatientsShow = false
      vm.financialExtractShow = false
      vm.balanceAndFinancialDataShow = false
      vm.profileShow = false
      vm.doctorClinicShow = false
      vm.dashboardDoctorShow = false
      vm.campaignsShow = false
      vm.contractsShow = true
    },
    showProfile () {
      const vm = this
      vm.appointmentShow = false
      vm.pendingScheduleShow = false
      vm.medicalRecordsShow = false
      vm.pendencyMedicalRecordsShow = false
      vm.financialExtractShow = false
      vm.balanceAndFinancialDataShow = false
      vm.profileShow = true
      vm.doctorClinicShow = false
      vm.dashboardDoctorShow = false
      vm.myPatientsShow = false
      vm.campaignsShow = false
      vm.contractsShow = false
    },
    showDoctorClinic () {
      const vm = this
      vm.appointmentShow = false
      vm.pendingScheduleShow = false
      vm.medicalRecordsShow = false
      vm.pendencyMedicalRecordsShow = false
      vm.financialExtractShow = false
      vm.balanceAndFinancialDataShow = false
      vm.profileShow = false
      vm.doctorClinicShow = true
      vm.dashboardDoctorShow = false
      vm.myPatientsShow = false
      vm.campaignsShow = false
      vm.contractsShow = false
    },
    showAppointment () {
      const vm = this
      vm.appointmentShow = true
      vm.pendingScheduleShow = false
      vm.medicalRecordsShow = false
      vm.pendencyMedicalRecordsShow = false
      vm.financialExtractShow = false
      vm.balanceAndFinancialDataShow = false
      vm.profileShow = false
      vm.doctorClinicShow = false
      vm.dashboardDoctorShow = false
      vm.myPatientsShow = false
      vm.campaignsShow = false
      vm.contractsShow = false
    },
    showPendingSchedule () {
      const vm = this
      vm.appointmentShow = false
      vm.pendingScheduleShow = true
      vm.medicalRecordsShow = false
      vm.pendencyMedicalRecordsShow = false
      vm.financialExtractShow = false
      vm.balanceAndFinancialDataShow = false
      vm.profileShow = false
      vm.doctorClinicShow = false
      vm.dashboardDoctorShow = false
      vm.myPatientsShow = false
      vm.campaignsShow = false
      vm.contractsShow = false
    },
    showMedicalRecords () {
      const vm = this
      vm.appointmentShow = false
      vm.pendingScheduleShow = false
      vm.medicalRecordsShow = true
      vm.pendencyMedicalRecordsShow = false
      vm.financialExtractShow = false
      vm.balanceAndFinancialDataShow = false
      vm.profileShow = false
      vm.doctorClinicShow = false
      vm.dashboardDoctorShow = false
      vm.myPatientsShow = false
      vm.campaignsShow = false
      vm.contractsShow = false
    },
    showPendencyMedicalRecords () {
      const vm = this
      vm.appointmentShow = false
      vm.pendingScheduleShow = false
      vm.medicalRecordsShow = false
      vm.pendencyMedicalRecordsShow = true
      vm.financialExtractShow = false
      vm.balanceAndFinancialDataShow = false
      vm.profileShow = false
      vm.doctorClinicShow = false
      vm.dashboardDoctorShow = false
      vm.myPatientsShow = false
      vm.campaignsShow = false
      vm.contractsShow = false
    },
    showMyPatients () {
      const vm = this
      vm.appointmentShow = false
      vm.pendingScheduleShow = false
      vm.medicalRecordsShow = false
      vm.pendencyMedicalRecordsShow = false
      vm.myPatientsShow = true
      vm.financialExtractShow = false
      vm.balanceAndFinancialDataShow = false
      vm.profileShow = false
      vm.doctorClinicShow = false
      vm.dashboardDoctorShow = false
      vm.campaignsShow = false
      vm.contractsShow = false
    },
    showFinancialExtract () {
      const vm = this
      vm.appointmentShow = false
      vm.pendingScheduleShow = false
      vm.medicalRecordsShow = false
      vm.pendencyMedicalRecordsShow = false
      vm.myPatientsShow = false
      vm.financialExtractShow = true
      vm.balanceAndFinancialDataShow = false
      vm.profileShow = false
      vm.doctorClinicShow = false
      vm.dashboardDoctorShow = false
      vm.campaignsShow = false
      vm.contractsShow = false
    },
    showBalanceAndFinancialData () {
      const vm = this
      vm.appointmentShow = false
      vm.pendingScheduleShow = false
      vm.medicalRecordsShow = false
      vm.pendencyMedicalRecordsShow = false
      vm.myPatientsShow = false
      vm.financialExtractShow = false
      vm.balanceAndFinancialDataShow = true
      vm.profileShow = false
      vm.doctorClinicShow = false
      vm.dashboardDoctorShow = false
      vm.campaignsShow = false
      vm.contractsShow = false
    },
    showCampaigns () {
      const vm = this
      vm.appointmentShow = false
      vm.pendingScheduleShow = false
      vm.medicalRecordsShow = false
      vm.pendencyMedicalRecordsShow = false
      vm.myPatientsShow = false
      vm.financialExtractShow = false
      vm.balanceAndFinancialDataShow = false
      vm.profileShow = false
      vm.doctorClinicShow = false
      vm.dashboardDoctorShow = false
      vm.campaignsShow = true
      vm.contractsShow = false
    },
    showDashboardDoctor () {
      const vm = this
      vm.appointmentShow = false
      vm.pendingScheduleShow = false
      vm.medicalRecordsShow = false
      vm.pendencyMedicalRecordsShow = false
      vm.myPatientsShow = false
      vm.financialExtractShow = false
      vm.balanceAndFinancialDataShow = false
      vm.profileShow = false
      vm.doctorClinicShow = false
      vm.dashboardDoctorShow = true
      vm.campaignsShow = false
      vm.contractsShow = false
    }
  }
}
</script>

<style lang="scss" src="./AdminVisionDoctor.scss"></style>